import React from "react";

const Achievements = () => {
  return (
    <section
      className="py-16 md:py-20 bg-white"
      aria-label="Awards and Achievements"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-[#729B7F] mb-3">
            Recognition
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Awards &amp; Achievements
          </h2>
          <div className="w-14 h-0.5 bg-gradient-to-r from-[#729B7F] to-[#abcacb] mx-auto" />
        </div>

        {/* Award Card */}
        <article className="bg-gradient-to-br from-white to-amber-50 border border-amber-100 rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row">
            {/* Award Image */}
            <div className="md:w-[45%] relative overflow-hidden">
              <img
                src="https://luvit.com.bd/wp-content/uploads/2025/08/8e9c20b4-d575-46f9-bcc2-e644849a4936-800x800.jpg"
                alt="South Asian Business Excellence Awards 2025 – Earth Beauty & You"
                className="w-full h-full object-cover min-h-[280px]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-amber-50/20 pointer-events-none md:block hidden" />
            </div>

            {/* Award Text */}
            <div className="md:w-[55%] p-6 sm:p-8 md:p-10 flex flex-col justify-center">
              {/* Badge */}
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wide text-amber-700 bg-amber-100 px-3 py-1.5 rounded-full w-fit mb-4">
                🏆 2025 Excellence Award
              </span>

              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-3 leading-tight">
                South Asian Business Excellence Awards 2025
              </h3>

              <p className="text-[#729B7F] font-semibold text-sm mb-4">
                Outstanding Achievement of Rising Star in Personal Care Industry
              </p>

              <p className="text-gray-600 leading-relaxed mb-4">
                Awarded to{" "}
                <strong className="text-gray-800">Imtiaz Ahmed</strong>,
                Director of{" "}
                <strong className="text-gray-800">Body &amp; Soul, USA</strong>,
                for excellence in driving innovation and growth in the{" "}
                <em>Earth Beauty &amp; You</em> brand.
              </p>

              <p className="text-xs text-gray-400 mb-5">
                Organized by <strong>Mirror World</strong> · Powered by{" "}
                <strong>Sandy Homes &amp; Resort Ltd.</strong>
              </p>

              <div className="space-y-3 text-gray-600 text-sm leading-relaxed border-t border-amber-100 pt-5">
                <p>
                  This recognition highlights our unwavering commitment to
                  delivering high-quality, sustainable, and innovative personal
                  care solutions that resonate with modern consumers.
                </p>
                <p>
                  At <em>Earth Beauty &amp; You</em>, we combine nature's best
                  ingredients with science-driven formulations to empower
                  individuals with confidence and care.
                </p>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};

export default Achievements;




// import React from "react";

// const Achievements = () => {
//   return (
//     <section className="bg-gradient-to-r from-red-50 to-gray-100 py-10 sm:py-12 px-4 sm:px-6 lg:px-20">
//       <div className="max-w-6xl mx-auto">
//         {/* Section Heading */}
//         <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 text-center mb-8 sm:mb-10">
//           Awards & Achievements
//         </h2>

//         {/* Award Card */}
//         <article className="bg-white shadow-lg rounded-2xl p-4 sm:p-6 md:p-8 hover:shadow-2xl transition duration-300">
//           <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-8">
//             {/* Award Image */}
//             <div className="w-full md:w-1/2">
//               <div className="relative w-full overflow-hidden rounded-xl">
//                 <img
//                   src="https://luvit.com.bd/wp-content/uploads/2025/08/8e9c20b4-d575-46f9-bcc2-e644849a4936-800x800.jpg"
//                   alt="South Asian Business Excellence Awards 2025 trophy and Earth Beauty & You branding"
//                   className="w-full h-full object-cover"
//                   loading="lazy"
//                 />
//               </div>
//             </div>

//             {/* Award Text */}
//             <div className="w-full md:w-1/2">
//               <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-900 mb-2 sm:mb-3">
//                 South Asian Business Excellence Awards 2025
//               </h3>

//               <p className="text-gray-700 leading-relaxed mb-2">
//                 {/* <span className="inline-block text-xs sm:text-sm font-semibold tracking-wide text-yellow-700 bg-yellow-100 px-2 py-1 rounded-md mr-2">
//                   Category
//                 </span> */} 
//                 <span className="align-middle">
//                   Outstanding Achievement of Rising Star in Personal Care Industry
//                 </span>
//               </p>

//               <p className="text-gray-700 leading-relaxed mb-3 sm:mb-4">
//                 Awarded to <span className="font-semibold">Imtiaz Ahmed</span>,
//                 Director of <span className="font-semibold">Body &amp; Soul, USA</span>,
//                 for excellence in driving innovation and growth in the{" "}
//                 <span className="italic">Earth Beauty &amp; You</span> brand.
//               </p>

//               <p className="text-xs sm:text-sm text-gray-500 mb-4 sm:mb-5">
//                 Organized by <span className="font-semibold">Mirror World</span>{" "}
//                 and powered by{" "}
//                 <span className="font-semibold">Sandy Homes &amp; Resort Ltd.</span>
//               </p>

//               {/* Extra Professional Text */}
//               <div className="space-y-3 sm:space-y-4">
//                 <p className="text-gray-700 leading-relaxed">
//                   This recognition highlights our unwavering commitment to
//                   delivering high-quality, sustainable, and innovative personal
//                   care solutions that resonate with modern consumers. It reflects
//                   the trust and support we’ve received from our customers,
//                   partners, and the global business community.
//                 </p>
//                 <p className="text-gray-700 leading-relaxed">
//                   At <span className="italic">Earth Beauty &amp; You</span>, we
//                   combine nature’s best ingredients with science-driven
//                   formulations to empower individuals with confidence and care.
//                   This award inspires us to keep pushing boundaries and set new
//                   standards in beauty and wellness.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </article>
//       </div>
//     </section>
//   );
// };

// export default Achievements;
